import { ConfirmEmailChangeResult, TConfirmEmailChange } from '@onesource/schemas';
import { useMutation } from '@tanstack/react-query';

import axios from '../../common/axios';
import { ENTITY } from './entity';

/**
 * Confirms an email change using the activation token from the new-address link.
 * Public endpoint — applies the change (Supabase + WP sync) on success.
 */
export const useConfirmEmailChangeMutation = () => {
  return useMutation<ConfirmEmailChangeResult, Error, TConfirmEmailChange>({
    mutationFn: async (payload: TConfirmEmailChange) => {
      const { data } = await axios.post<ConfirmEmailChangeResult>(`${ENTITY}/email-change/confirm`, payload);
      return data;
    },
  });
};
